module.exports = __webpack_public_path__ + "fbe5c3c611dfdc9d8fd9de61d2f5b6db.MP3";